import { Box, Typography } from "@mui/material";
import {
  CHART_CONTAINER_HEIGHT,
  STANDART_CHART_HEIGHT,
} from "../../system-health/common/values";

import CircularLoading from "../../../../../common/components/progress/CircularLoading";
import SimplePaperWrapper from "../../../../../common/components/item/SimplePaperWrapper";
import StatisticsNoDataView from "./StatisticsNoDataView";
import StyledChart from "../../../../../common/components/apexchart/StyledChart";
import { TimePeriod } from "../../../../../API";
import TimePeriodFilter from "./TimePeriodFilter";
import { useMostActiveLocationsChart } from "../hooks/useMostActiveLocationsChart";
import { useState } from "react";

const MostActiveLocationsContainer = (): JSX.Element => {
  const [activeTimePeriod, setActiveTimePeriod] = useState<TimePeriod>(
    TimePeriod.ONE_WEEK
  );

  const handleTimePeriodChange = (timePeriod: TimePeriod): void => {
    if (timePeriod !== activeTimePeriod) {
      setActiveTimePeriod(timePeriod);
    }
  };

  const { series, options, loading, refetching, showNoData } =
    useMostActiveLocationsChart(activeTimePeriod);

  return (
    <SimplePaperWrapper
      sx={{
        padding: "1.5em",
        width: "100%",
        height: CHART_CONTAINER_HEIGHT,
        borderRadius: "8px",
      }}
    >
      <Box
        sx={{
          display: "flex",
        }}
      >
        <Typography variant="h5">Most active locations</Typography>
        <Box
          sx={{
            display: "flex",
            marginLeft: "auto",
          }}
        >
          <TimePeriodFilter
            activePeriod={activeTimePeriod}
            setActivePeriod={handleTimePeriodChange}
          />
        </Box>
      </Box>
      {(loading || refetching) && <CircularLoading />}
      {!loading && !showNoData && (
        <StyledChart
          options={options}
          series={series}
          height={STANDART_CHART_HEIGHT}
          type="bar"
        />
      )}
      {showNoData && <StatisticsNoDataView />}
    </SimplePaperWrapper>
  );
};

export default MostActiveLocationsContainer;
